<template>
  <div class="toolPage">
    <div class="tool_item flex-rowc"><i class="iconfont icon-liebiaofenlei"></i></div>
    <div class="tool_item flex-rowc" @click="backTop"><i class="iconfont icon-arrow"></i></div>
  </div>
</template>
<script>
export default {
  name: "myTool",
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    // 返回顶部
    backTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
<style scoped lang="less">
.toolPage {
  position: fixed;
  right: 0;
  bottom: 5%;
  transform: translateY(-50%);
  z-index: 9999;
  .tool_item {
    width: 60px;
    height: 60px;
    background: #FFFFFF;
    border-radius: 50%;
    margin-bottom: 30px;
    cursor: pointer;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    i {
      font-size: 30px;
      color: #000000;
      display: inline-block;
    }
    .icon-arrow {
      transform: rotate(90deg);
    }
  }
}
</style>